import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Pin } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Robert Miller",
  role: "Verified Patient",
  quote: "After years of struggling with CPAP, the oral appliance from A Sleep Dentist changed everything. I finally wake up feeling truly rested and alert.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/avatar_robert_m.png",
  color: "text-secondary"
}, {
  id: 2,
  name: "Sarah Lansing",
  role: "Verified Patient",
  quote: "The team is so professional. They handled my insurance seamlessly, and my snoring is completely gone. My family is finally sleeping through the night.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/avatar_sarah_l.png",
  color: "text-secondary"
}, {
  id: 3,
  name: "James K.",
  role: "Verified Patient",
  quote: "I was skeptical about a dental solution for sleep apnea, but the results speak for themselves. It's comfortable, discreet, and highly effective.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/avatar_james_k.png",
  color: "text-secondary"
}, {
  id: 4,
  name: "Linda Thompson",
  role: "Verified Patient",
  quote: "Empathetic care from start to finish. They truly understand the struggle of chronic exhaustion and provided a solution that actually works.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/avatar_linda_t.png",
  color: "text-secondary"
}, {
  id: 5,
  name: "Mark Stevens",
  role: "Verified Patient",
  quote: "A total game changer for my health. The appliance is so much easier to travel with than a machine. I wish I had done this years ago.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/avatar_mark_s.png",
  color: "text-secondary"
}];
export default function VoicesOfResilience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="52489" id="patient-success-stories" ref={ref} className={`bg-primary text-primary-foreground py-24 px-4 overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center">
          <span className="inline-block py-1 px-3 rounded-full bg-secondary text-secondary-foreground text-sm font-bold uppercase tracking-wider mb-4">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-white mb-4">
            Patient Success Stories
          </h2>
          <p className="text-lg text-primary-foreground/80 max-w-2xl mx-auto font-sans">
            Hear from our patients who have reclaimed their nights, restored their vitality, and found a better way to treat sleep apnea.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4 pb-10">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="h-full pt-6">
                  <Card className="relative h-full bg-white border-none shadow-xl rounded-[24px] overflow-visible mt-4">
                    {}
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-10 drop-shadow-md">
                      <Pin className={`size-8 fill-current ${testimonial.color} rotate-12 opacity-90`} />
                    </div>

                    <CardContent className="flex flex-col items-center text-center pt-12 pb-8 px-6 h-full">
                      <SafeHydrate><Avatar className="size-20 mb-4 border-4 border-secondary/20 shadow-sm">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.name} className="object-cover" />
                        <AvatarFallback className="bg-muted text-primary text-lg font-bold">
                          {testimonial.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>

                      <blockquote className="font-sans italic text-slate-600 text-lg mb-6 flex-grow leading-relaxed">
                        "{testimonial.quote}"
                      </blockquote>

                      <div className="mt-auto">
                        <h3 className="font-sans text-xl font-bold text-primary">
                          {testimonial.name}
                        </h3>
                        <p className="font-sans text-sm font-semibold text-secondary uppercase tracking-wide">
                          {testimonial.role}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-end gap-4 mt-4 pr-4">
            <CarouselPrevious className="static translate-none bg-white/10 hover:bg-secondary hover:text-secondary-foreground border-white/20 text-white" />
            <CarouselNext className="static translate-none bg-white/10 hover:bg-secondary hover:text-secondary-foreground border-white/20 text-white" />
          </div>
        </Carousel>
      </div>
    </section>;
}